import React, { ReactElement, ReactNode } from "react";
import { NavLink, useLocation } from "react-router";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Divider from "@mui/material/Divider";
import { useHasPermission } from "@/hooks";
import { isLocationActive } from "@/common/Methods";
import { alpha, ListItemText } from "@mui/material";

interface Level2MenuItemProps {
  link: string;
  label: string;
  feature: string;
  codes: string[];
  icon?: ReactNode;
}

export const Level2MenuItem = ({
  link,
  label,
  codes,
  feature,
}: Level2MenuItemProps): ReactElement | null => {
  const location = useLocation();
  const { allow } = useHasPermission(codes, feature);

  const isActive = isLocationActive(location, link);
  const activeColor = isActive
    ? "leftMenu.textColorActive"
    : "leftMenu.textColorInActive";

  if (!allow) {
    return null;
  }

  return (
    <NavLink
      to={link}
      style={{
        textDecoration: "none",
      }}
    >
      <ListItem
        sx={{
          pl: 0,
          pr: 0,
          py: 0,
          color: activeColor,
        }}
      >
        <Divider
          orientation="vertical"
          flexItem
          sx={(theme) => ({
            marginX: 1,
            borderWidth: "1px",
            borderColor: isActive
              ? theme.palette.leftMenu.borderColorActive
              : theme.palette.leftMenu.borderColorInActive,
          })}
        />
        <ListItemButton
          sx={(theme) => ({
            p: 1,
            borderRadius: "8px",
            backgroundColor: isActive
              ? alpha(theme.palette.leftMenu.backgroundColorSelected, 0.28)
              : "transparent",
          })}
        >
          <ListItemText primary={label} />
        </ListItemButton>
      </ListItem>
    </NavLink>
  );
};
